import { cloneDeep } from "common/utils/core";
import { jotaiStore, summaryAtom } from "components/jiffy/react-product-details-dtf/store.atoms";

// eslint-disable-next-line import/prefer-default-export
export class DtfPricesDecorator {
  extraCharge = 0;

  updateCostInfo(data) {
    const newData = cloneDeep(data);
    const { cart_dates: cartDates, composition_dates: compositionDates } = newData;
    if (cartDates?.shipping_cost_info) {
      cartDates.shipping_cost_info.amount_until_free -= this.extraCharge;
      cartDates.shipping_cost_info.free = cartDates.shipping_cost_info.amount_until_free <= 0;
    }
    if (compositionDates?.shipping_cost_info) {
      compositionDates.shipping_cost_info.amount_until_free -= this.extraCharge;
      compositionDates.shipping_cost_info.free =
        compositionDates.shipping_cost_info.amount_until_free <= 0;
    }
    return newData;
  }

  #unsubscribe = null;

  #updateExtraCharge() {
    const summary = jotaiStore.get(summaryAtom);
    this.extraCharge = 0;
    Object.values(summary?.enhancements || {}).forEach(enhancement => {
      this.extraCharge += parseFloat(enhancement.totalPrice) || 0;
    });
  }

  subscribe() {
    this.#unsubscribe = jotaiStore.sub(summaryAtom, () => {
      this.#updateExtraCharge();
    });
    this.#updateExtraCharge();
  }

  unsubscribe() {
    this.#unsubscribe?.();
    this.#unsubscribe = null;
  }
}
